import { createContext, useState } from "react";

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [token, setToken] = useState(localStorage.getItem("token") || null);

  const [activeBranch, setActiveBranch] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("activeBranch")) || null;
    } catch {
      return null;
    }
  });

  const login = (userToken) => {
    setToken(userToken);
    localStorage.setItem("token", userToken);
  };

  // Called from Header switcher when user changes entity
  const switchBranch = (branch) => {
    setActiveBranch(branch);
    localStorage.setItem("activeBranch", JSON.stringify(branch));
  };

  const logout = () => {
    setToken(null);
    setActiveBranch(null);
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("user_id");
    localStorage.removeItem("user");
    localStorage.removeItem("activeBranch");
  };

  return (
    <AuthContext.Provider value={{ token, login, logout, activeBranch, switchBranch }}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
